import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { Card } from "@blueprintjs/core";
import { faCodeBranch, faTerminal } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useBasePath, useUrlSearch } from "@hooks";

const Container = styled.div`
  padding: 36px 40px 24px 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  min-height: 100%;
`;

const Header = styled.div`
  font-size: 32px;
`;

const SetupCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  flex-grow: 1;
  justify-content: center;
`;

const StyledCard = styled(Card)`
  padding: 100px 72px;
  text-align: center;
  height: 440px;
  width: 440px;
  border-radius: 10px;
  position: relative;
`;

const CardTitle = styled.div`
  font-size: var(--global-font-size-l);
  margin: 44px 0 16px;
`;

const CardText = styled.div``;

const Ribbon = styled.div`
  position: absolute;
  font-size: var(--global-font-size-xs);
  color: #ffffff;
  background-color: var(--indigo1);
  top: 20px;
  left: -4px;
  padding: 6px 16px 6px 10px;
  clip-path: polygon(0 0, 100% 0, 95% 50%, 100% 100%, 0% 100%);
`;

const InfoBubble = styled.div`
  font-size: var(--global-font-size-xs);
`;

const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SetupProjectPanel = () => {
  const history = useHistory();
  const basePath = useBasePath();
  const { search } = useUrlSearch();

  return (
    <Container>
      <Header>Scan new project</Header>
      <SetupCards>
        <StyledCard
          data-testid="run-locally"
          interactive
          elevation={1}
          onClick={() => history.push(`${basePath}/setup/local`)}
        >
          <Ribbon>Quick Start: Takes 3 Minutes!</Ribbon>
          <FontAwesomeIcon
            icon={faTerminal}
            color={"var(--indigo1)"}
            size="4x"
          />
          <CardTitle>Run a scan locally</CardTitle>
          <CardText>
            From our command line tool, run a couple simple commands to explore
            results of a scan in the app.
          </CardText>
        </StyledCard>
        <StyledCard
          interactive
          elevation={1}
          onClick={() => {
            search.set("select-ci", "select-ci");
            history.push({
              search: search.toString(),
            });
          }}
          data-testid="run-ci"
        >
          <FontAwesomeIcon
            icon={faCodeBranch}
            color={"var(--indigo1)"}
            size="4x"
          />
          <CardTitle>Run scan in CI</CardTitle>
          <CardText>
            Scan continuously using Github Actions, Gitlab CI/CD, Jenkins,
            Circle CI, or other tools.
          </CardText>
        </StyledCard>
      </SetupCards>
      <InfoDiv>
        <InfoBubble>
          Your source code will never be sent anywhere.{" "}
          <a
            href="https://semgrep.dev/docs/faq/#is-private-source-code-shared-with-r2c"
            target="_blank"
            rel="noopener noreferrer"
          >
            See what data will be uploaded.
          </a>
        </InfoBubble>
      </InfoDiv>
    </Container>
  );
};
